import { cleanStringField } from 'js/utilities/strings';
import {
  isStaffLawyerType,
  isCooperatingLawyerType,
} from 'js/utilities/lawyers';

export const resolveStringValueForCooperatingLawyer = (
  value = '',
  isCooperatingLawyer = false
) => {
  return isCooperatingLawyer ? value : '';
};

export const formatNtpInfo = (data) => {
  const { clientInfo = {}, lawyerInfo = {}, caseInfo = {} } = data;
  const { caseInformationResponse = {}, caseLawyerResponse = {} } = caseInfo;
  const { cif, legalProblemDesc } = caseInformationResponse;
  const { lawyerType } = caseLawyerResponse;

  const { clientPersonal = {} } = clientInfo || {};
  const {
    firstName: clientFirstName,
    lastName: clientLastName,
  } = clientPersonal;
  const {
    lawyerId,
    firstName: lawyerFirstName = '',
    lastName: lawyerLastName = '',
    address: lawyerAddress = '',
    address2: lawyerAddress2 = '',
    city: lawyerCity = '',
    province: lawyerProvince = '',
    postalCode: lawyerPostalCode = '',
    phoneNumber: lawyerPhone = '',
    firmName = '',
  } = lawyerInfo || {};

  const isStaffLawyer = isStaffLawyerType(lawyerType);
  const isCooperatingLawyer = isCooperatingLawyerType(lawyerType);

  return {
    cif,
    legalProblem: legalProblemDesc,
    client: {
      firstName: clientFirstName,
      lastName: clientLastName,
    },
    lawyer: {
      isStaffLawyer,
      isCooperatingLawyer,
      lawyerId: cleanStringField(lawyerId),
      firmName: resolveStringValueForCooperatingLawyer(
        firmName,
        isCooperatingLawyer
      ),
      firstName: resolveStringValueForCooperatingLawyer(
        lawyerFirstName,
        isCooperatingLawyer
      ),
      lastName: resolveStringValueForCooperatingLawyer(
        lawyerLastName,
        isCooperatingLawyer
      ),
      address: resolveStringValueForCooperatingLawyer(
        lawyerAddress,
        isCooperatingLawyer
      ),
      address2: resolveStringValueForCooperatingLawyer(
        lawyerAddress2,
        isCooperatingLawyer
      ),
      city: resolveStringValueForCooperatingLawyer(
        lawyerCity,
        isCooperatingLawyer
      ),
      province: resolveStringValueForCooperatingLawyer(
        lawyerProvince,
        isCooperatingLawyer
      ),
      postalCode: resolveStringValueForCooperatingLawyer(
        lawyerPostalCode,
        isCooperatingLawyer
      ),
      phone: resolveStringValueForCooperatingLawyer(
        lawyerPhone,
        isCooperatingLawyer
      ),
    },
  };
};
